@if (data["navData"] && data["navData"].expanded?.children) {
  <nav>
    <span
      (click)="
        toggleMobileNav($event);
        interactionClickEvent('/', 'Toggle mobile nav', 'Mobile nav')
      "
      [ngClass]="{ active: mobileNav }"
      class="navigation__menu-button js-nav-menu-button"
    >
      <lg-icon name="hamburger-menu" />
      @if (mobileMenuLabel) {
        <span [innerHTML]="mobileMenuLabel"></span>
      }
    </span>

    <div
      [ngClass]="{
        'open-top': mobileNav
      }"
      class="navigation__background navigation__background--primary navigation__background--visible opens-top"
    >
      <div class="navigation__container">
        <ul
          aria-busy="true"
          class="navigation__list navigation__list--primary"
          role="menu"
        >
          @for (
            mainItem of data["navData"].expanded.children;
            let i = $index;
            let last = $last;
            track i
          ) {
            <li
              [class.flex-grow-align-end]="
                last &&
                headerData.moveLastNavItemToTheRight &&
                headerData.headerStyle !== 'tall'
              "
              [class.move-right]="
                last &&
                headerData.moveLastNavItemToTheRight &&
                headerData.headerStyle === 'tall'
              "
              class="navigation__item"
              role="presentation"
            >
              @if (!mainItem.expanded.children) {
                <dotcom-frontend-link
                  (click)="
                    interactionClickEvent(
                      mainItem.expanded.ctaButton?.href,
                      mainItem.expanded.menuTitle,
                      mainItem.expanded.routeSegment
                    )
                  "
                  [attr.role]="'presentation'"
                  [linkClass]="{
                    active: isActiveRoute(
                      formatUrl(mainItem.expanded.ctaButton?.href),
                      null,
                      i
                    ),
                    navigation__link: true
                  }"
                  [url]="mainItem.expanded.ctaButton?.href"
                  role="menuitem"
                  [tabindex]="activeMainNav > -1 ? -1 : 0"
                  [lgFocus]="mainItemFocus === i"
                  (blur)="mainItemFocus = undefined"
                >
                  {{ mainItem.expanded.menuTitle }}
                </dotcom-frontend-link>
              } @else {
                <div
                  (click)="
                    toggleMainNav($event, i);
                    interactionClickEvent(
                      mainItem.expanded.ctaButton?.href,
                      mainItem.expanded.menuTitle,
                      mainItem.expanded.routeSegment
                    )
                  "
                  (keydown.enter)="toggleMainNav($event, i)"
                  (keydown.esc)="toggleMainNav($event, i)"
                  [ngClass]="{
                    active: isActiveRoute(
                      formatUrl(mainItem.expanded.ctaButton?.href),
                      mainItem.expanded.children,
                      i
                    ),
                    open: activeMainNav === i
                  }"
                  class="navigation__link"
                  role="menuitem"
                  [tabindex]="activeMainNav > -1 ? -1 : 0"
                  [lgFocus]="mainItemFocus === i"
                  (blur)="mainItemFocus = undefined"
                >
                  {{ mainItem.expanded.menuTitle }}
                  <lg-icon class="navigation__link-icon" name="caret-right" />
                </div>
              }
            </li>
          }
          <li
            [class.flex-no-grow]="headerData.moveLastNavItemToTheRight"
            class="header__links inside-nav"
            role="presentation"
          >
            @if (headerData.searchResultsPage) {
              <div
                (click)="
                  toggleMainNav($event, 999);
                  interactionClickEvent('href', 'search', 'routeSegment')
                "
                (keydown.enter)="toggleMainNav($event, 999)"
                (keydown.esc)="toggleMainNav($event, 999)"
                [ngClass]="{
                  active: isActiveRoute(
                    formatUrl(headerData.searchTitle),
                    null,
                    0
                  ),
                  open: activeMainNav === 999
                }"
                class="navigation__link navigation-search__menu-item"
                role="menuitem"
                [tabindex]="activeMainNav > -1 ? -1 : 0"
                [lgFocus]="mainItemFocus === 999"
                (blur)="mainItemFocus = undefined"
              >
                <lg-icon class="navigation-search__icon" name="search" />
                {{ headerData.searchTitle }}
              </div>
            }

            @if (
              headerData.availableLanguagesForPage &&
              headerData.availableLanguagesForPage.length > 1
              ) {
              <div class="navigation-language__container">
                <div
                  (click)="toggleLanguages()"
                  (keyup.enter)="toggleLanguages()"
                  class="navigation__link navigation-language__menu-item"
                  [class.menu-open]="isLanguageMenu"
                  role="menuitem"
                  [tabindex]="activeMainNav > -1 ? -1 : 0"
                >
                  <lg-icon
                    class="navigation-language__icon"
                    name="chat" />

                    {{ currentLanguage.name }}

                  <lg-icon
                    class="navigation-language__icon--right"
                    name="caret-right"
                  />

              </div>
              <div
                role="menu"
                [class.menu-open]="isLanguageMenu"
                [class.tall-header]="isLanguageMenu && headerData.headerStyle === 'tall'"
                class="navigation-language__dropdown box-shadow"
                >
                <div class="navigation-language__container">
                  <span
                    (click)="toggleLanguages()"
                    class="navigation-language--back"
                    ><lg-icon name="chevron-left"></lg-icon>
                    Back
                  </span>
                  <div class="navigation-language__title lg-font--expressive lg-font-size-4--medium"> Select a language </div>
                    @for (language of headerData.availableLanguagesForPage; let i = $index; track i) {
                      <div
                        class="language__item"
                        role="presentation">
                          <dotcom-frontend-link
                          [attr.role]="'presentation'"
                          [url]="language.link"
                          role="menuitem"
                          [class.active]="currentLanguage.name === language.displayName"
                        >
                          <lg-icon
                            class="language__item--tick-icon"
                            name="checkmark"
                          >
                          </lg-icon>
                          {{ language.displayName }}
                        </dotcom-frontend-link>
                      </div>
                      }
                      </div>
                    </div>
                </div>
              }

              @if (headerData) {
                <dotcom-frontend-header-links [headerLinksData]="headerData" />
              }
            </li>

            @if (headerData) {
              <li class="navigation__item navigation-search" role="presentation">
                @if (headerData.searchResultsPage) {
                  <div class="navigation-search__mobile">
                    @if (searchMobileComponent) {
                      <dotcom-frontend-loader
                        [componentData]="searchMobileComponent"
                      />
                    }
                  </div>
                }
              </li>
            }
          </ul>
      </div>
    </div>

    <div aria-busy="true" class="header__links tall outside-nav" role="menubar">
      <div class="header__links-wrapper">
        @if (headerData.searchResultsPage) {
          <div
            (click)="
              toggleMainNav($event, 999);
              interactionClickEvent('href', 'search', 'routeSegment')
            "
            (keydown.enter)="toggleMainNav($event, 999)"
            (keydown.esc)="toggleMainNav($event, 999)"
            [ngClass]="{
              active: isActiveRoute(formatUrl(headerData.searchTitle), null, 0),
              open: activeMainNav === 999
            }"
            class="navigation__link navigation-search__menu-item"
            role="menuitem"
            [tabindex]="activeMainNav > -1 ? -1 : 0"
          >
            <lg-icon class="navigation-search__icon" name="search" />
            {{ headerData.searchTitle }}
          </div>
        }

        @if (
              headerData.availableLanguagesForPage &&
              headerData.availableLanguagesForPage.length > 1
              ) {
              <div class="navigation-language__container tall-header">
                <div
                  (click)="toggleLanguages()"
                  (keyup.enter)="toggleLanguages()"
                  class="navigation__link navigation-language__menu-item"
                  [class.menu-open]="isLanguageMenu"
                  role="menuitem"
                  [tabindex]="activeMainNav > -1 ? -1 : 0"
                >
                  <lg-icon
                    class="navigation-language__icon"
                    name="chat" />

                    {{ currentLanguage.name }}

                  <lg-icon
                    class="navigation-language__icon--right"
                    name="caret-right"
                  />

              </div>
              <div
                role="menu"
                [class.menu-open]="isLanguageMenu"
                class="navigation-language__dropdown box-shadow"
                >
                <div class="navigation-language__container">
                  <span
                    (click)="toggleLanguages()"
                    class="navigation-language--back"
                    ><lg-icon name="chevron-left"></lg-icon>
                    Back
                  </span>
                  <div class="navigation-language__title lg-font--expressive lg-font-size-4--medium"> Select a language </div>
                    @for (language of headerData.availableLanguagesForPage; let i = $index; track i) {
                      <div
                        class="language__item"
                        role="presentation">
                          <dotcom-frontend-link
                          [attr.role]="'presentation'"
                          [url]="language.link"
                          role="menuitem"
                          [class.active]="currentLanguage.name === language.displayName"
                        >
                          <lg-icon
                            class="language__item--tick-icon"
                            name="checkmark"
                          >
                          </lg-icon>
                          {{ language.displayName }}
                        </dotcom-frontend-link>
                      </div>
                      }
                      </div>
                    </div>
                </div>
              }

        @if (headerData) {
          <dotcom-frontend-header-links [headerLinksData]="headerData" />
        }
      </div>
    </div>

    @for (
      mainItem of data["navData"].expanded.children;
      let i = $index;
      track i
    ) {
      @if (mainItem.expanded.children || mainItem.expanded.promoBlock) {
        <div
          (keydown.esc)="toggleMainNav($event, i)"
          [ngClass]="{
            'open-right': activeMainNav === i,
            'has-audience-nav': true
          }"
          class="navigation__background opens-right navigation__height"
        >
          <div class="navigation__container navigation__container--main">
            @if (!displayBackButton()) {
              <span (click)="activeMainNav = -1" class="navigation__back">
                <lg-icon name="chevron-left" /> Back
              </span>
            }
            <ul aria-busy="true" class="navigation__list" role="menu">
              <li role="presentation">
                @if (progressiveRevealNavigationOnDesktop) {
                  <div
                    class="navigation__section-container progressive-reveal-navigation"
                    lgRow
                  >
                    @if (!isMobile || (isMobile && showRootNav)) {
                      <div
                        [lgColLg]="3"
                        [lgColSm]="12"
                        class="navigation__section no-top-border no-bottom-border no-left-border"
                      >
                        <div class="navigation__submenu-intro">
                          @if (mainItem.expanded.introTitle) {
                            <div
                              class="navigation__submenu-intro-title lg-font--expressive lg-font-size-4--medium"
                            >
                              {{ mainItem.expanded.introTitle }}
                            </div>
                          }

                          @if (mainItem.expanded.introDescription) {
                            <p class="navigation__submenu-intro-text">
                              {{ mainItem.expanded.introDescription }}
                            </p>
                          }
                        </div>
                        @if (mainItem.expanded.ctaButton?.text) {
                          <dotcom-frontend-link
                            (click)="
                              interactionClickEvent(
                                mainItem.expanded.ctaButton?.href,
                                mainItem.expanded.ctaButton.text,
                                mainItem.expanded.routeSegment
                              )
                            "
                            [attr.role]="'presentation'"
                            [tabindex]="
                              activeMainNav === i && openedMenus.length === 0
                                ? 0
                                : -1
                            "
                            [url]="mainItem.expanded.ctaButton?.href"
                            role="menuitem"
                            [isLgButton]="true"
                            [lgButtonVariant]="'primary-dark'"
                          >
                            {{ mainItem.expanded.ctaButton?.text }}
                          </dotcom-frontend-link>
                        }
                      </div>
                    }
                    <div [lgColLg]="9" [lgColSm]="12">
                      <div
                        class="progressive-reveal-navigation__back-container"
                      >
                        @if (displayBackButton()) {
                          <button
                            tabindex="-1"
                            class="progressive-reveal-navigation__back"
                            (click)="
                              progressiveNavigateBack();
                              interactionClickEvent(
                                'BackSubmenu',
                                backButtonLabel,
                                'progressive-reveal-navigation'
                              )
                            "
                          >
                            <lg-icon name="chevron-left" />
                            {{ backButtonLabel }}
                          </button>
                        }
                      </div>
                      <div
                        lgRow
                        class="progressive-reveal-navigation__container"
                        [id]="'scrollContainer-' + mainItem.id"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            progNavTemplate;
                            context: {
                              childMenu: mainItem.expanded.children?.[0],
                              level: 0,
                              parentId: mainItem.id,
                              parentIndex: i
                            }
                          "
                        ></ng-container>
                        @if (showPromoBox() && contentArea && contentArea[i]) {
                          <div
                            [lgColLgOffset]="promoBoxOffset()"
                            [lgColLg]="4"
                            [lgColSm]="12"
                            class="navigation__section progressive-reveal-navigation--promo"
                          >
                            @for (
                              item of contentArea[i];
                              let i = $index;
                              track i
                            ) {
                              <dotcom-frontend-loader
                                [componentData]="item"
                                [parent]="'navigation'"
                              />
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                } @else {
                  <div class="navigation__submenu-intro">
                    @if (mainItem.expanded.introTitle) {
                      <div
                        class="navigation__submenu-intro-title lg-font--expressive lg-font-size-4--medium"
                      >
                        {{ mainItem.expanded.introTitle }}
                      </div>
                    }

                    @if (mainItem.expanded.introDescription) {
                      <p class="navigation__submenu-intro-text">
                        {{ mainItem.expanded.introDescription }}
                      </p>
                    }
                  </div>
                  <dotcom-frontend-link
                    (click)="
                      interactionClickEvent(
                        mainItem.expanded.ctaButton?.href,
                        mainItem.expanded.ctaButton.text,
                        mainItem.expanded.routeSegment
                      )
                    "
                    [attr.role]="'presentation'"
                    [tabindex]="activeMainNav === i ? 0 : -1"
                    [url]="mainItem.expanded.ctaButton?.href"
                    linkClass="navigation__link navigation__link--cta"
                    role="menuitem"
                  >
                    {{ mainItem.expanded.ctaButton?.text }}
                  </dotcom-frontend-link>
                  <div class="navigation__section-container" lgRow>
                    @for (
                      column of getColumns(mainItem.expanded);
                      let columnIndex = $index;
                      track columnIndex
                    ) {
                      <div
                        [lgColLg]="3"
                        [lgColSm]="12"
                        [ngClass]="{
                          'navigation__section--no-title':
                            !column.expanded.columnTitle
                        }"
                        class="navigation__section"
                      >
                        @if (column.expanded.columnTitle || hasIntroTitle) {
                          <div
                            (click)="toggleSecondaryNav($event, columnIndex)"
                            class="navigation__section-title"
                            [ngClass]="{'navigation__section-title--empty': !column.expanded.columnTitle}"
                          >
                            {{ column.expanded.columnTitle || "&nbsp;" }}

                            @if (column.expanded.children) {
                              <lg-icon
                                class="navigation__link-icon"
                                name="caret-right"
                              />
                            }
                          </div>
                        }
                        <div
                          [ngClass]="{
                            'open-right':
                              activeSecondaryNav === columnIndex ||
                              !column.expanded.columnTitle,
                            'navigation__background--no-title':
                              !column.expanded.columnTitle
                          }"
                          class="navigation__background navigation__background--visible navigation__background--top opens-right navigation__height"
                        >
                          <div class="navigation__container">
                            @if (column.expanded.columnTitle) {
                              <span
                                (click)="activeSecondaryNav = -1"
                                class="navigation__back"
                                ><lg-icon name="chevron-left"></lg-icon>
                                Back</span
                              >
                            }

                            @if (column.expanded.columnTitle) {
                              <div class="navigation__list-title">
                                {{ column.expanded.columnTitle }}
                              </div>
                            }

                            @if (column.expanded.children) {
                              <ul class="navigation__list" role="menu">
                                @for (
                                  item of column.expanded.children;
                                  let ii = $index;
                                  track ii
                                ) {
                                  @if (!checkLinkAvailability(item.expanded.targetUrl)) {<li
                                    class="navigation__item--secondary"
                                    role="presentation"
                                  >
                                    <dotcom-frontend-link
                                      [attr.role]="'presentation'"
                                      [tabindex]="activeMainNav === i ? 0 : -1"
                                      [url]="item.expanded.targetUrl"
                                      linkClass="navigation__link navigation__link--secondary"
                                      role="menuitem"
                                    >
                                      {{ item.expanded.title }}
                                    </dotcom-frontend-link>
                                  </li>}
                                }
                              </ul>
                            }
                          </div>
                        </div>
                      </div>
                    }

                    @if (mainItem.expanded.promoBlock) {
                      <div
                        [lgColLgOffset]="
                          promoColumnOffset(mainItem.expanded.children?.length)
                        "
                        [lgColLg]="3"
                        [lgColSm]="12"
                        class="navigation__section navigation__section--promo"
                      >
                        @if (contentArea && contentArea[i]) {
                          @for (
                            item of contentArea[i];
                            let i = $index;
                            track i
                          ) {
                            <dotcom-frontend-loader
                              [componentData]="item"
                              [parent]="'navigation'"
                            />
                          }
                        }
                      </div>
                    }
                  </div>
                }
              </li>
            </ul>
            <button
              class="navigation__close"
              [tabindex]="activeMainNav === i ? 0 : -1"
              aria-label="Close"
              (blur)="focusMainItem(i)"
              (keydown.enter)="toggleMainNav($event, i)"
              (click)="toggleMainNav($event, i)"
            >
              <lg-icon name="close" />
            </button>
          </div>
        </div>
      }
    }
    <div
      (keydown.esc)="toggleMainNav($event, 999)"
      [ngClass]="{
        'open-right': activeMainNav === 999
      }"
      class="navigation__background opens-right"
    >
      <div class="navigation-search__container" lgContainer>
        @if (searchComponent) {
          <dotcom-frontend-loader
            cssClass="navigation-search__component"
            [componentData]="searchComponent"
          />
        }
        <button
          class="navigation__close"
          [tabindex]="activeMainNav === 999 ? 0 : -1"
          aria-label="Close"
          (blur)="focusMainItem(999)"
          (keydown.enter)="toggleMainNav($event, 999)"
          (click)="toggleMainNav($event, 999)"
        >
          <lg-icon name="close" />
        </button>
      </div>
    </div>
  </nav>
}

<ng-template
  #progNavTemplate
  let-childMenu="childMenu"
  let-level="level"
  let-parentId="parentId"
  let-parentIndex="parentIndex"
>
  <div
    [lgColLg]="4"
    [lgColSm]="12"
    class="navigation__section navigation__section--no-title navigation__section--progressive no-top-border no-bottom-border"
    [ngClass]="{
      active: level === 0 || isActive(childMenu.id)
    }"
  >
    <ul aria-busy="true" role="menu">
      @if (level > 0) {
        <li class="column-title" role="presentation">
          {{ childMenu.expanded.name }}
        </li>
      }
      @for (
        child of childMenu.expanded.children;
        let menuIndex = $index;
        track menuIndex
      ) {
        <li role="presentation">
          @if (child.expanded.children) {
            <button
              class="navigation__item"
              [tabindex]="
                (activeMainNav === parentIndex &&
                  level === openedMenus.length) ||
                isActive(child.id)
                  ? 0
                  : -1
              "
              [ngClass]="{
                active: isActive(child.id)
              }"
              (click)="
                openSubMenu(level, child.id, parentId);
                interactionClickEvent(
                  'OpenSubmenu',
                  child.expanded.name,
                  'progressive-reveal-navigation'
                )
              "
            >
              <span>{{ child.expanded.title }}</span>
              <lg-icon name="chevron-right"></lg-icon>
            </button>
          } @else {
            <dotcom-frontend-link
              [attr.role]="'presentation'"
              [tabindex]="
                activeMainNav === parentIndex && level === openedMenus.length
                  ? 0
                  : -1
              "
              [url]="child.expanded.targetUrl"
              linkClass="progressive-reveal-navigation__link"
              role="menuitem"
            >
              <span>{{ child.expanded.title }}</span>
            </dotcom-frontend-link>
          }
        </li>
      }
    </ul>
  </div>
  @for (
    child of childMenu.expanded.children;
    let menuIndex = $index;
    track menuIndex
  ) {
    @if (child.expanded.children) {
      <ng-container
        *ngTemplateOutlet="
          progNavTemplate;
          context: { childMenu: child, level: level + 1, parentId, parentIndex }
        "
      ></ng-container>
    }
  }
</ng-template>
